import React, { useState, useEffect } from "react";

const CountdownTimer = ({ eventDate }) => {
  // Helper function to calculate time remaining
  const calculateTimeLeft = () => {
    const difference = new Date(eventDate) - new Date();
    if (difference <= 0) return null;
    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    // Update the countdown every second
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    // Cleanup the timer interval when the component unmounts
    return () => clearInterval(timer);
  }, [eventDate]);

  if (!timeLeft) {
    return (
      <div style={{ textAlign: "center", fontSize: "16px" }}>
        <span>Event has started!</span>
      </div>
    );
  }

  return (
    <div style={{ textAlign: "center", fontSize: "16px", fontWeight: "bold" }}>
      <span style={{ margin: "0 8px" }}>{timeLeft.days}d</span>
      <span style={{ margin: "0 8px" }}>{timeLeft.hours}h</span>
      <span style={{ margin: "0 8px" }}>{timeLeft.minutes}m</span>
      <span style={{ margin: "0 8px" }}>{timeLeft.seconds}s</span>
    </div>
  );
};

export default CountdownTimer;
